/**
 * Latest Posts Block Frontend JavaScript
 * Handles carousel/slider functionality using Embla Carousel
 */
(function () {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check if EmblaCarousel is available
    if (typeof EmblaCarousel === 'undefined') {
      console.warn('EmblaCarousel is not loaded');
      return;
    }

    const carouselBlocks = document.querySelectorAll('.latest-posts-carousel');

    carouselBlocks.forEach((carouselElement) => {
      initCarousel(carouselElement);
    });
  }

  function initCarousel(carouselElement) {
    const block = carouselElement.closest('.latest-posts');
    const prevButton = block.querySelector('.latest-posts-prev');
    const nextButton = block.querySelector('.latest-posts-next');

    if (!prevButton || !nextButton) {
      return;
    }

    // Get the number of columns from the block class
    let slidesToScroll = 1;
    if (block.classList.contains('columns-2')) {
      slidesToScroll = 1;
    } else if (block.classList.contains('columns-3')) {
      slidesToScroll = 1;
    } else if (block.classList.contains('columns-4')) {
      slidesToScroll = 1;
    }

    // Initialize Embla Carousel
    const embla = EmblaCarousel(carouselElement, {
      align: 'start',
      slidesToScroll: slidesToScroll,
      skipSnaps: false, // Smooth snapping to each slide
      draggable: true,
      dragFree: false, // Allows duration setting to work (dragFree overrides duration)
      duration: 20, // Lower = faster (20-60 recommended range, 25 is default)
    });

    // Update button states
    const updateButtonStates = () => {
      prevButton.disabled = !embla.canScrollPrev();
      nextButton.disabled = !embla.canScrollNext();
    };

    // Navigation button handlers
    prevButton.addEventListener('click', () => {
      embla.scrollPrev();
    });

    nextButton.addEventListener('click', () => {
      embla.scrollNext();
    });

    // Update buttons on scroll and init
    embla.on('select', updateButtonStates);
    embla.on('init', updateButtonStates);

    // Reinitialize on window resize for responsive behavior
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        embla.reInit();
      }, 250);
    });

    // Initial button state
    updateButtonStates();
  }
})();
